import React from 'react';
import { Link } from 'react-router-dom';

// KPI tile. tone: brand | info | warning | danger | violet | slate
const StatCard = ({ label, value, icon, tone = 'brand', foot, to }) => {
    const body = (
        <>
            <span className={`hp-stat-icon hp-tone-${tone}`}><i className={`bi ${icon}`}></i></span>
            <div className="min-w-0">
                <div className="hp-stat-label">{label}</div>
                <div className="hp-stat-value">{value ?? 0}</div>
                {foot && <div className="hp-stat-foot">{foot}</div>}
            </div>
        </>
    );
    return to
        ? <Link to={to} className="hp-card hp-stat">{body}</Link>
        : <div className="hp-card hp-stat">{body}</div>;
};

export default StatCard;
